import { HttpErrorResponse } from '@angular/common/http';
import { AskErrorKind } from 'src/app/enums/askErrorKind.enum';

export function classifyAskError(error: unknown): AskErrorKind {
  if (error instanceof HttpErrorResponse) {
    if (error.status === 402) {
      return AskErrorKind.InsufficientCredit;
    }
    if (error.status === 403) {
      return AskErrorKind.AnalystDisabled;
    }
    if (error.status === 429) {
      return AskErrorKind.RateLimited;
    }
    if (error.status === 400) {
      return AskErrorKind.ValidationFailed;
    }
    if (error.status >= 500) {
      return AskErrorKind.ServerFailure;
    }
    if (error.status === 0) {
      return AskErrorKind.ConnectionLost;
    }
  }
  return AskErrorKind.Generic;
}

const MAX_USABLE_MESSAGE_LENGTH = 300;
const MAX_RETRY_AFTER_SECONDS = 3600;

export function extractAskErrorMessage(error: unknown): string | null {
  if (!(error instanceof HttpErrorResponse)) {
    return null;
  }

  const body: unknown = error.error;
  const message = typeof body === 'string' ? body : (body as { message?: unknown } | null)?.message;

  if (typeof message !== 'string') {
    return null;
  }

  const trimmed = message.trim();
  return isUsableMessage(trimmed) ? trimmed : null;
}

// Contract: a usable message is plain, single-line text with no markup characters.
// The rejected character list (`<`, `>`, newlines) is intentional, not incidental —
// it keeps the helper safe to reuse in contexts that do not escape their output.
export function isUsableMessage(message: string): boolean {
  return (
    message.length > 0 &&
    message.length <= MAX_USABLE_MESSAGE_LENGTH &&
    !message.includes('<') &&
    !message.includes('>') &&
    !message.includes('\n')
  );
}

export function extractRetryAfterSeconds(error: unknown): number | null {
  if (!(error instanceof HttpErrorResponse)) {
    return null;
  }

  const header = error.headers.get('Retry-After');
  if (!header) {
    return null;
  }

  const seconds = Number(header);
  return Number.isFinite(seconds) && seconds > 0 && seconds <= MAX_RETRY_AFTER_SECONDS ? Math.round(seconds) : null;
}
